import {
    apiRequest,
    acmanajerialList,
    acmanajerialActive,
    acmanajerialInactive
} from "../../../../../services/adapters/kepegawaian/Accompetence"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", acmanajerialList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", acmanajerialInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", acmanajerialActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository